import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings, Settings } from '../../app.settings';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  viewRenderReady = false;

  pageInject: boolean = false;
  mblInject: boolean = false;

  ngProgressColor = "#082A54";

  public settings: Settings;
  constructor(public appSettings: AppSettings,
    public router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    public title: Title,
    public translate: TranslateService) {
    this.settings = this.appSettings.settings;
    translate.addLangs(['en', 'de', 'fr', 'ru', 'tr']);
    translate.setDefaultLang('en');
    translate.use('en');
  }

  ngAfterViewInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          if (isPlatformBrowser(this.platformId)) {
            window.scrollTo(0, 0);
            this.checkPlatform();
            this.checkProgressColor();
          }
        });
      }
    });
    this.viewRenderReady = true;
  }

  checkPlatform() {
    if (this.router.url.includes('/mbl')) {
      this.pageInject = true;
      this.mblInject = true;
    }
    if (this.router.url.includes('portal/kaupsagan')) {
      this.pageInject = true;
    }
  }

  checkProgressColor() {
    if (this.mblInject) {
      this.ngProgressColor = "#008800";
    }
  }

}
